// types listed will have annotation controls
export const ANNOTATABLE_TYPES = ["image", "handwritten", "book_illustration"];

// toggles icon class search refinement interface, by default enabled
export const SHOW_IC_REFINEMENT =
  (process.env.REACT_APP_SHOW_IC_REFINEMENT || "1") === "1";

export const DEFAULT_SECTION = process.env.REACT_APP_DEFAULT_SECTION || "all";

export const SEARCH = {
  DEFAULT_HPP: "999",
  AUTH_TOKEN_URL: process.env.REACT_APP_AUTH_TOKEN_URL,
  PATH_BASE: process.env.REACT_APP_PATH_BASE || "",
  PATH_SEARCH: "/api/search",
  PATH_OBJECTS: "/api/objects",
  PATH_LISTS: "/api/lists",
  PATH_MODIFY: "/api/modify",
  PATH_ENTRY: "/api/entry",
  PATH_USER: "/api/user",
  PATH_TRANSLATE: "/api/translate",
  PATH_PREVIEW: "/api/preview",
  PARAM_SEARCH: "q=",
  PARAM_PAGE: "page=",
  PARAM_HPP: "size=",
  PARAM_SECTION: "section=",
  PARAM_SORT: "sort=",
};

export const PROJECT_NAME =
  process.env.REACT_APP_API_PROJECT_NAME || "arkyves_dev";
